import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import DetailsHeaderBar from "../components/DetailsHeaderBar";
import DetailsTopBar from "../components/DetailsTopBar";
import WalletDetails from "../components/WalletDetails";
import cash from "../assets/images/tc-cash-wallet 1.png";
import units from "../assets/images/tc-units-wallet 2.png";
import mini from "../assets/images/tcuk_agent_wallet 2.png";
import "../styles/AdvertisingAgentWallet.css";

function AdvertisingAgentWallet() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  if (!agent) {
    return <p style={{ padding: "30px" }}>No more data available.</p>;
  }

  // Extract wallet data from the nested structure
  const agentWalletBalance =
    agent.agent_wallet_details?.points ||
    agent.agent_details?.wallet_balance ||
    agent.agent_wallet_points ||
    0;

  const customerWalletBalance =
    agent.customer_details?.wallet_details?.total_points ||
    agent.customer_wallet_points ||
    agent.wallet_details?.total_points ||
    0;

  const primaryWalletBalance =
    agent.customer_details?.wallet_details?.primary_wallet?.points ||
    agent.wallet_details?.primary_wallet?.points ||
    0;

  // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/advertising-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/advertising-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/advertising-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Request Details",
      path: "/advertising-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Advertising Agent Details"
          subtitle="You can edit your details to update your profile"
          breadcrumbs={[
            { label: "Home", path: "/dashboard" },
            {
              label: "Manage Customer Advertising Agent",
              path: "/manage-advertising-agent",
            },
            { label: "Advertising Agent Details" },
          ]}
        />
        <DetailsTopBar tabs={tabs} activeTab="wallet" agent={agent} />
        <div className="wallet-section">
          {/* FIRST WALLET FULL WIDTH - AGENT WALLET (Only show if agent is approved) */}
          {agent.status === "approved" && (
            <div className="wallet-full">
              <WalletDetails
                title="TCUK Mini Advertising Agent Wallet"
                image={mini}
                balanceLabel="Available Balance"
                balanceValue={`${agentWalletBalance} TopCoin`}
                historyPath="/advertising-agent-transaction"
                stateData={{ agent }}
                variant="mini"
              />
            </div>
          )}

          {/* TWO WALLETS SIDE BY SIDE - CUSTOMER WALLETS */}
          <div className="wallet-row">
            <WalletDetails
              title="TCUK TopCoin Wallet"
              image={units}
              balanceLabel="Available Balance"
              balanceValue={`${customerWalletBalance} TopCoin`}
              historyPath="/advertising-agent-transaction-history"
              stateData={{ agent }}
            />

            <WalletDetails
              title="TCUK Cash Wallet"
              image={cash}
              balanceLabel="Available Balance"
              balanceValue="N/A"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvertisingAgentWallet;
